var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnitureSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_9389_79022)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 15.4004C11.0243 15.4004 11.4313 15.569 11.7313 15.869C12.0314 16.1691 12.1999 16.576 12.1999 17.0004V18.6003H20.1998V17.0004C20.1998 16.576 20.3683 16.1691 20.6684 15.869C20.9685 15.569 21.3754 15.4004 21.7997 15.4004C22.2241 15.4004 22.631 15.569 22.9311 15.869C23.2311 16.1691 23.3997 16.576 23.3997 17.0004V20.2003C23.3997 20.6246 23.2311 21.0316 22.9311 21.3316C22.631 21.6317 22.2241 21.8003 21.7997 21.8003H10.6C10.1756 21.8003 9.76867 21.6317 9.46862 21.3316C9.16857 21.0316 9 20.6246 9 20.2003V17.0004C9 16.576 9.16857 16.1691 9.46862 15.869C9.76867 15.569 10.1756 15.4004 10.6 15.4004V15.4004Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 15.3999V11.4C10.5999 10.7634 10.8527 10.153 11.3028 9.70293C11.7529 9.25285 12.3633 9 12.9998 9H19.3997C20.0362 9 20.6466 9.25285 21.0967 9.70293C21.5468 10.153 21.7996 10.7634 21.7996 11.4V15.3999",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 21.8008V23.4007",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 21.8008V23.4007",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_9389_79022",
    x: -17.662,
    y: -17.662,
    width: 67.324,
    height: 67.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79022",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureSmall);
export default __webpack_public_path__ + "static/media/furnitureSmall.3da2843a8a7d8468a5d1fe4ff4cef5bd.svg";
export { ForwardRef as ReactComponent };